import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, toImg } from "@/api/client";
import ContactForm from "@/components/ContactForm";
import SEO, { articleSchema, breadcrumbSchema } from "@/components/SEO";

function renderMarkdownLite(text) {
  if (!text) return null;
  const lines = text.split(/\n/);
  const out = [];
  let listBuf = [];
  const flushList = () => {
    if (listBuf.length) {
      out.push(<ul key={out.length}>{listBuf.map((li, i) => <li key={i}>{li}</li>)}</ul>);
      listBuf = [];
    }
  };
  lines.forEach((line, i) => {
    if (line.startsWith("### ")) { flushList(); out.push(<h3 key={i}>{line.slice(4)}</h3>); }
    else if (line.startsWith("## ")) { flushList(); out.push(<h2 key={i}>{line.slice(3)}</h2>); }
    else if (line.startsWith("- ")) { listBuf.push(line.slice(2)); }
    else if (line.trim() === "") { flushList(); }
    else { flushList(); out.push(<p key={i}>{line}</p>); }
  });
  flushList();
  return out;
}

export default function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPost(null);
    setNotFound(false);
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return (
    <div className="container-cnp py-24 text-center">
      <h1 className="font-display text-3xl">Artigo não encontrado</h1>
      <Link to="/blog" className="btn-secondary mt-6 inline-flex">Ver todos os artigos</Link>
    </div>
  );
  if (!post) return <div className="container-cnp py-24">A carregar...</div>;

  const canonical = `https://casanoporto.com/blog/${post.slug}`;

  return (
    <div data-testid={`page-blog-post-${post.slug}`}>
      <SEO
        title={post.seo_title || post.title}
        description={post.meta_description || post.summary}
        canonical={canonical}
        image={toImg(post.main_image)}
        jsonLd={[
          articleSchema(post, canonical),
          breadcrumbSchema([
            { name: "Início", url: "https://casanoporto.com/" },
            { name: "Blog", url: "https://casanoporto.com/blog" },
            { name: post.title, url: canonical },
          ]),
        ]}
      />
      <section className="container-cnp pt-10">
        <Link to="/blog" className="text-sm text-stone-500 hover:text-[#103C4A]">← Voltar ao blog</Link>
        <span className="tag-chip mt-4 inline-flex">{post.category}</span>
        <h1 className="mt-4 font-display text-3xl md:text-5xl text-stone-900 leading-tight">{post.title}</h1>
        <div className="mt-3 text-sm text-stone-500">{post.author} · {new Date(post.date).toLocaleDateString("pt-PT")}</div>
      </section>
      <section className="container-cnp py-10">
        {post.main_image && <img src={toImg(post.main_image)} alt={post.title} className="w-full rounded-3xl aspect-[16/8] object-cover" />}
      </section>
      <section className="container-cnp pb-16 grid lg:grid-cols-12 gap-10">
        <article className="lg:col-span-8 prose-cnp max-w-none">
          {renderMarkdownLite(post.content)}
        </article>
        <aside className="lg:col-span-4">
          <div className="card-soft p-6 sticky top-24">
            <h3 className="text-lg text-stone-900">Falar com a Zélia</h3>
            <p className="mt-2 text-sm text-stone-600">Ficou com dúvidas? Escreva-me.</p>
            <div className="mt-6">
              <ContactForm compact testidPrefix={`blog-${post.slug}-contact`} />
            </div>
          </div>
        </aside>
      </section>
    </div>
  );
}
